import {
    IdCardIcon,
    UpdateIcon,
} from '@radix-ui/react-icons';
import { useEffect, useState } from 'react';
import { Button } from '../ui/button';
import {
    Dialog,
    DialogClose,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "../ui/dialog";
import { DropdownMenuItem } from "../ui/dropdown-menu";

import api from '../../lib/api';
import { DatePickerWithRange } from '../daterangeWithpicker';
import { Checkbox } from '../ui/checkbox';
import { Label } from '../ui/label';
import { toast } from '../ui/use-toast';

function UpdateMembershipDialog({ user, fetchClubMembers, isDialogOpen, setIsDialogOpen, onlyMount }) {
    const [isLoading, setIsLoading] = useState(false);
    const [selectedDates, setSelectedDates] = useState({ from: null, to: null });
    const [miniMember, setMiniMember] = useState(false)
    const [familyMembership, setFamilyMember] = useState(false)
    const [regularMembership, setRegularMembership] = useState(true);

    useEffect(() => {
        setSelectedDates({ from: null, to: null }); // Reset selected dates
        setMiniMember(user?.minimember);
        setFamilyMember(user?.familymembership);
    }, [user?.minimember, user?.familymembership]);

    const handleChange = async (e) => {
        if (isLoading) return;

        e.preventDefault();
        setIsLoading(true);

        const fromDate = selectedDates.from ? convertToUTC(selectedDates.from) : user.membership_started.split("T")[0];
        const toDate = selectedDates.to ? convertToUTC(selectedDates.to) : user.membership_expiration.split("T")[0];

        try {
            const response = await api.put(`https://skhrf-api.cmdigital.se/v1/clubs/membership`, {
                targetUserId: user.id,
                newStartedDate: fromDate,
                newExpirationDate: toDate,
                isMiniMember: miniMember,
                isFamilyMembership: familyMembership,
            });
            fetchClubMembers();
            setIsDialogOpen(false);
            setIsLoading(false);

            toast({
                title: 'Medlemskap uppdaterat',
                description: `${user?.first_name} ${user?.last_name}s medlemskap blev uppdaterat till ${fromDate} - ${toDate}. Minimedlem: ${miniMember}, Familjemedlemskap: ${familyMembership}`,
            });
        } catch (error) {
            console.error(error);
            toast({
                variant: 'destructive',
                title: 'Något gick fel.',
                description: error?.response?.data?.error,
            });
        } finally {
            setIsLoading(false);
        }
    };

    const convertToUTC = (date) => {
        return new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString().split('T')[0];
    };

    const isMembershipValid = () => {
        if (miniMember) {
            return true;
        }
        if (!familyMembership && !regularMembership) {
            return false;
        }
        if (familyMembership && regularMembership) {
            return false;
        }
        return true;
    };

    return (
        <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
            {onlyMount !== true && (
                <DropdownMenuItem onSelect={(event) => event.preventDefault()} >
                    <DialogTrigger className='flex items-center w-full'>
                        <IdCardIcon className='mr-3' />
                        Uppdatera medlemskap
                    </DialogTrigger>
                </DropdownMenuItem>
            )}
            <DialogContent className="flex flex-col gap-6" onOpenAutoFocus={(e) => e.preventDefault()}>
                <DialogHeader className='text-left'>
                    <DialogTitle>Uppdatera medlemskap</DialogTitle>
                    <DialogDescription>Ange information för att uppdatera medlemskapet för {user?.first_name} {user?.last_name}</DialogDescription>
                </DialogHeader>
                <div className='flex flex-col gap-2'>
                    <Label className='flex gap-2'>
                        <Checkbox checked={miniMember} onCheckedChange={(checked) => setMiniMember(checked)} />
                        Minimedlem
                    </Label>
                    {!miniMember && (
                        <>
                            <Label className='flex gap-2'>
                                <Checkbox checked={familyMembership} onCheckedChange={(checked) => setFamilyMember(checked)} />
                                Familjemedlemsskap
                            </Label>
                            <Label className='flex gap-2'>
                                <Checkbox checked={regularMembership} onCheckedChange={(checked) => setRegularMembership(checked)} />
                                Vanligt medlemsskap
                            </Label>
                        </>
                    )}
                </div>
                {!miniMember && (
                    <div className='flex flex-col gap-2'>
                        <DatePickerWithRange
                            className='w-full'
                            disabled={isLoading}
                            id='datePicker'
                            defaultDate={{ to: user?.membership_expiration, from: user?.membership_started }}
                            onDateChange={(range) => setSelectedDates(range)}
                        />
                    </div>
                )}
                <div className='grid grid-cols-2 gap-3'>
                    <DialogClose asChild>
                        <Button type='button' variant='secondary'>Avbryt</Button>
                    </DialogClose>
                    <Button type="submit" onClick={handleChange} disabled={isLoading || !isMembershipValid()}>
                        {isLoading ? <UpdateIcon className='loader-spinner' /> : <>Uppdatera</>}
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default UpdateMembershipDialog;
